import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    position: 'fixed',
    left: '50%',
    bottom: theme.spacing(5),
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: 8,
    display: 'flex',
    transform: 'translateX(-50%)',
    background: theme.palette.background.paper,
    overflow: 'hidden',
  },
  countContainer: {
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.primary.main,
    padding: theme.spacing(1, 2),
    color: theme.palette.primary.contrastText,
  },
  count: {
    fontSize: theme.typography.h5.fontSize,
    marginRight: theme.spacing(1.5),
  },
  label: {
    fontWeight: theme.typography.fontWeightLight,
  },
}))
